import { defineField } from '@/form/useForm'
import type { UseAssetFormComputedData, UseAssetFormState } from '../types'
import {
  EAssetAutomationLevel,
  EAssetSource,
  evaluateAssetAutomationLevel,
  type IProviderImport
} from 'findef'
import { lockedByIr, lockedByProvider, lockedByTicker } from '../toolips'
import { EFormEventHookOrder } from '@/form/useForm/eventHook'
import { formatOrgNbr } from '@/utils/asset'

export const organizationNumberField = (needs: string[] = [
  'asset.cryptoQuote',
  'asset.companyProfile',
  'asset.commodityQuote',
  'asset.listed',
  'providerImport',
  'asset.provider',
  'manualTicker'
]) => {
  return defineField<UseAssetFormState, any, UseAssetFormComputedData>({
    hooks: {
      manualTicker: {
        order: EFormEventHookOrder.EARLY,
        fun: () => {
          return {
            value: ''
          }
        }
      }
    },
    label: 'Organization Number',
    type: 'text',
    placeholder: 'Enter Number',
    needs: needs,
    next: (state) => {
      const providerImport = state.asset.providerImport as IProviderImport | null | undefined;
      const company = state.asset.companyProfile;
      const crypto = state.asset.cryptoQuote;
      const commodity = state.asset.commodityQuote;
      return {
        value: state.manualTicker
          ? state.asset.organizationNumber ? formatOrgNbr(state.asset.organizationNumber) : state.asset.organizationNumber
          : state.asset.cryptoQuote?.prettySymbol ||
            state.asset.cryptoQuote?.symbol ||
            state.asset.commodityQuote?.symbol ||
            state.asset.commodityQuote?.name ||
            (!state.asset.companyProfile?.listed && state.asset.companyProfile?.isin ? formatOrgNbr(state.asset.companyProfile?.isin) : state.asset.companyProfile?.isin) ||
            state.asset.organizationNumber,
        locked:
          evaluateAssetAutomationLevel(state.asset) === EAssetAutomationLevel.SEMI_AUTOMATIC ||
          state.asset.source === EAssetSource.IR ||
          !!state.providerImport ||
          !!state.asset.provider ||
          (!!state.asset.companyProfile && state.asset.companyProfile.manuallyAdded !== true),

        ...(state.asset.source === EAssetSource.IR
          ? lockedByIr(state)
          : providerImport
            ? lockedByProvider(state)
            : ((company && company.manuallyAdded !== true) || (crypto && crypto.manuallyAdded !== true) || ( commodity && commodity.manuallyAdded !== true )) ? lockedByTicker(state) : {
                lockedReason: 'This field is maintained by another source',
                lockedReasonBubbletip: undefined
              }),

        placeholder: state.asset.listed ? '12 Numbers' : 'Enter Number',
        tooltip: state.asset.listed
          ? 'ISIN is an acronym for International Securities Identification Number. ISIN numbers are the unique 12-digit numbers that are recognized by the International Standards Organization'
          : 'The business registration number is a unique identifier assigned to legal entities, such as companies and associations',
        label: state.asset.listed ? 'ISIN Code' : 'Organization Number'
      }
    }
  })
}
